import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-deleteno",
  "use": "icon-deleteno-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-deleteno\">\n<circle cx=\"9.99935\" cy=\"9.99935\" r=\"7.83333\" stroke=\"#CCCCCC\" />\n<rect x=\"14.6992\" y=\"9.24902\" width=\"1.5\" height=\"9.39941\" rx=\"0.75\" transform=\"rotate(90 14.6992 9.24902)\" fill=\"#CCCCCC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol